/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { Promocode } from './Promocode'
import {
  PromocodeFromJSON,
  PromocodeFromJSONTyped,
  PromocodeToJSON,
} from './Promocode'

/**
 *
 * @export
 * @interface GetActivePromoCode200Response
 */
export interface GetActivePromoCode200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetActivePromoCode200Response
   */
  status: boolean
  /**
   *
   * @type {Promocode}
   * @memberof GetActivePromoCode200Response
   */
  data?: Promocode | null
}

/**
 * Check if a given object implements the GetActivePromoCode200Response interface.
 */
export function instanceOfGetActivePromoCode200Response(
  value: object
): value is GetActivePromoCode200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  return true
}

export function GetActivePromoCode200ResponseFromJSON(
  json: any
): GetActivePromoCode200Response {
  return GetActivePromoCode200ResponseFromJSONTyped(json, false)
}

export function GetActivePromoCode200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetActivePromoCode200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: json['data'] == null ? undefined : PromocodeFromJSON(json['data']),
  }
}

export function GetActivePromoCode200ResponseToJSON(
  value?: GetActivePromoCode200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: PromocodeToJSON(value['data']),
  }
}
